if (!customElements.get("m-recently-viewed")) {
  class MRecentlyViewed extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper"
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.productsPerRow;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      this.productsToshow = parseInt(this.dataset.productsToShow, 10);

      /*
       * IMPORTANT:
       * The original file only READ minimog-recently-viewed but never wrote
       * the currently viewed product to it. Register it here on product pages.
       */
      this.registerCurrentProduct();

      MinimogTheme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    registerCurrentProduct() {
      const productId = parseInt(this.dataset.productId, 10);
      if (!productId) return;

      try {
        let viewed = JSON.parse(
          window.localStorage.getItem("minimog-recently-viewed") || "[]"
        );

        if (!Array.isArray(viewed)) viewed = [];

        viewed = viewed
          .map((id) => parseInt(id, 10))
          .filter((id) => Number.isFinite(id) && id !== productId);

        // Most recently viewed first.
        viewed.unshift(productId);

        // Keep a reasonable history without changing section's display limit.
        viewed = viewed.slice(0, 30);

        window.localStorage.setItem(
          "minimog-recently-viewed",
          JSON.stringify(viewed)
        );
      } catch (error) {
        // Do not break the section if storage is unavailable.
      }
    }

    init() {
      const query = this.getQueryString();

      // No previous products yet: don't send an empty Shopify search request.
      if (!query) {
        this.classList.add("m:hidden");
        return;
      }

      fetch(this.dataset.url + encodeURIComponent(query))
        .then((response) => response.text())
        .then((html) => {
          const wrapper = document.createElement("div");
          wrapper.innerHTML = html;

          const section = wrapper.querySelector("m-recently-viewed");

          // Original code dereferenced section before checking it existed.
          if (!section) {
            this.classList.add("m:hidden");
            return;
          }

          this.products = section.querySelectorAll(".m-product-card").length;

          if (this.products <= 0) {
            this.classList.add("m:hidden");
            return;
          }

          if (section.innerHTML.trim().length) {
            this.innerHTML = section.innerHTML;
            this.classList.remove("m:hidden");
            this.initByScreenSize();

            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });

            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });

            if (MinimogTheme.CompareProduct) {
              MinimogTheme.CompareProduct.setCompareButtonsState();
            }

            if (MinimogTheme.Wishlist) {
              MinimogTheme.Wishlist.setWishlistButtonsState();
            }
          }
        })
        .catch(() => {
          // Keep the storefront stable if the request fails.
        });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;

      const {
        slideContainer,
        slideControls
      } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        if (slideControls) slideControls.classList.add("m:hidden");
        if (slideContainer) slideContainer.classList.remove("swiper-container");

        if (this.swiper) {
          this.swiper.destroy(false, true);
        }
      } else {
        if (slideControls) slideControls.classList.remove("m:hidden");
        this.initSlider();
      }

      if (
        this.products <= parseInt(this.items, 10) &&
        slideControls
      ) {
        slideControls.classList.add("m:hidden");
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      if (!slideContainer) return;

      const controls = this.querySelector(".m-slider-controls");
      const prev = controls &&
        controls.querySelector(".m-slider-controls__button-prev");
      const next = controls &&
        controls.querySelector(".m-slider-controls__button-next");
      const swiperWrapper = slideContainer.querySelector(".swiper-wrapper");

      if (!swiperWrapper) return;

      const childCount = swiperWrapper.childElementCount;

      slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: !(this.products <= parseInt(this.items, 10)),
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true
            }
          : false,
        breakpoints: {
          768: {
            slidesPerView:
              parseInt(this.items, 10) >= 3 ? 3 : parseInt(this.items, 10)
          },
          1024: {
            slidesPerView:
              parseInt(this.items, 10) >= 4 ? 4 : parseInt(this.items, 10)
          },
          1280: {
            slidesPerView: parseInt(this.items, 10)
          }
        },
        threshold: 2,
        on: {
          init: () => {
            setTimeout(() => {
              const image =
                this.querySelector(".m-image") ||
                this.querySelector(".m-placeholder-svg");

              if (image && controls) {
                controls.style.setProperty(
                  "--offset-top",
                  parseInt(image.clientHeight, 10) / 2 + "px"
                );

                if (prev) prev.classList.remove("m:hidden");
                if (next) next.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, config) => {
            if (!controls) return;

            const { slidesPerView } = config;

            if (childCount > slidesPerView) {
              controls.classList.remove("m:hidden");
              swiper.allowTouchMove = true;
            } else {
              controls.classList.add("m:hidden");
              swiper.allowTouchMove = false;
            }
          }
        }
      });

      if (this.slider && this.showNavigation) {
        if (prev) {
          prev.addEventListener("click", () => this.slider.slidePrev());
        }

        if (next) {
          next.addEventListener("click", () => this.slider.slideNext());
        }
      }

      this.swiper = slideContainer.swiper;
    }

    getQueryString() {
      let viewed;

      try {
        viewed = JSON.parse(
          window.localStorage.getItem("minimog-recently-viewed") || "[]"
        );
      } catch (error) {
        viewed = [];
      }

      if (!Array.isArray(viewed)) return "";

      const currentProductId = parseInt(this.dataset.productId, 10);

      // Work on a copy only; keep the current product stored for future pages.
      const ids = viewed
        .map((id) => parseInt(id, 10))
        .filter(
          (id) =>
            Number.isFinite(id) &&
            (!currentProductId || id !== currentProductId)
        )
        .slice(0, this.productsToshow);

      return ids.map((id) => "id:" + id).join(" OR ");
    }
  }

  customElements.define("m-recently-viewed", MRecentlyViewed);
}
